import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Swiper, { Navigation } from 'swiper';
import { formatImage } from '@src/common/formatImage';

Swiper.use([Navigation]);

const LargeSwiper = (props) => {
    const { content } = props;

    useEffect(() => {
        new Swiper('#swiper2', {
            autoplay: true,
            slidesPerView: 4,
            spaceBetween: 5,
            navigation: {
                prevEl: '#prev2',
                nextEl: '#next2'
            },
        });
    }, []);

    return (
        <div className={styles.swiperWp}>
            {
                content.length > 4 && <div className={styles.prev2} id="prev2" />
            }
            <div className={styles.swiper2}>
                <div className="swiper" id="swiper2">
                    <div className="swiper-wrapper">
                        {
                            content.reverse().map((item, index) => {
                                return (
                                    <div className="swiper-slide" key={index}>
                                        <a href={item.url} target="_blank" rel="noreferrer">
                                            <div className={styles.imgWp}>
                                                <img className={styles.swiperImage} src={formatImage(item.image, 246 * 2, 437 * 2)} alt="" />
                                            </div>
                                        </a>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="swiper-pagination2" />
                </div>
            </div>
            {
                content.length > 4 && <div className={styles.next2} id="next2" />
            }
        </div>
    );
};

LargeSwiper.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(LargeSwiper);
